import { NodeViewWrapper } from "@tiptap/react"
import { useEffect, useState } from "react";
import { getAllProducts } from '../../../../../api/productsApi';

export const ProductsBlockView = (props) => {
    const { editor, getPos, node } = props;
    const [isPopular, setIsPopular] = useState(node?.attrs?.isPopular || false);
    const [latest, setLatest] = useState(node?.attrs?.latest || true);
    const [isHotDeal, setIsHotDeal] = useState(node?.attrs?.isHotDeal || false);
    const [isBuilderChoice, setIsBuilderChoice] = useState(node?.attrs?.isBuilderChoice || false);
    const [isProPicks, setIsProPicks] = useState(node?.attrs?.isProPicks || false);
    const [isTrendingNow, setIsTrendingNow] = useState(node?.attrs?.isTrendingNow || false);
    const [mostOrdered, setMostOrdered] = useState(node?.attrs?.mostOrdered || false);
    const [productCount, setCategoryCount] = useState(node?.attrs?.productCount || 5);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setIsPopular(node?.attrs?.isPopular || false);
        setLatest(node?.attrs?.latest ?? true);
        setIsHotDeal(node?.attrs?.isHotDeal || false);
        setIsBuilderChoice(node?.attrs?.isBuilderChoice || false);
        setIsProPicks(node?.attrs?.isProPicks || false);
        setIsTrendingNow(node?.attrs?.isTrendingNow || false);
        setMostOrdered(node?.attrs?.mostOrdered || false);
        setCategoryCount(node?.attrs?.productCount || 5);
    }, [node]);

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const queryParams = {};
                if (isPopular) queryParams.isPopular = isPopular;
                if (latest) queryParams.latest = latest;
                if (isHotDeal) queryParams.isHotDeal = isHotDeal;
                if (isBuilderChoice) queryParams.isBuilderChoice = isBuilderChoice;
                if (isProPicks) queryParams.isProPicks = isProPicks;
                if (isTrendingNow) queryParams.isTrendingNow = isTrendingNow;
                if (mostOrdered) queryParams.mostOrdered = mostOrdered;
                if (productCount) queryParams.productCount = productCount;

                const response = await getAllProducts(queryParams);
                setProducts(response?.data?.data || []);
            } catch (error) {
                console.error('Error fetching products:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchProducts();
    }, [isPopular, latest, isHotDeal, productCount, isBuilderChoice, isProPicks, isTrendingNow, mostOrdered]);

    const handleCaptionClick = () => {
        const nodePosition = getPos();
        editor.commands.setNodeSelection(nodePosition);
    };

    return (
        <>
            <NodeViewWrapper data-type='products'>
                <div className="products-node-wrapper"
                    data-isPopular={node.attrs.isPopular}
                    data-latest={node.attrs.latest}
                    data-isHotDeal={node.attrs.isHotDeal}
                    data-isBuilderChoice={node.attrs.isBuilderChoice}
                    data-isProPicks={node.attrs.isProPicks}
                    data-isTrendingNow={node.attrs.isTrendingNow}
                    data-mostOrdered={node.attrs.mostOrdered}
                    data-productCount={node.attrs.productCount}
                >
                    <div className='products-content' onClick={handleCaptionClick}>
                        {loading ? (
                            <div className={`ringLoader loaderContinue`}></div>
                        ) : (
                            <div className='product-grid'>
                                {
                                    products?.slice(0, 5)?.map((product) => {
                                        return (
                                            <div key={product.id} className="product-card" data-image={product?.image?.key}>

                                                <div className="product-image">
                                                    <img src={product?.image?.url} alt={product.title} />
                                                </div>
                                                <p className="product-category">{product?.categories?.map(item => item?.name).join(' | ')}</p>
                                                <h3 className="product-title">{product.title}</h3>
                                                <div className="price-wrapper">
                                                    MRP <span className="new-price">₹{product.priceFrom} - ₹{product.priceTo}</span>
                                                    <span className="unit">/ {product.unit}</span>
                                                </div>

                                                <div className="rating">
                                                    4.5 ⭐⭐⭐⭐ | 40 Ratings
                                                </div>
                                                <button className="add-to-cart-btn">Add to Cart</button>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )}
                    </div>
                </div>
            </NodeViewWrapper>
        </>
    )
}